import type { ProjectVisual as ProjectVisualType } from "../types/content";

export function ProjectVisual({ type }: { type: ProjectVisualType }) {
  if (type === "lidar") {
    return (
      <svg className="project-visual-svg" viewBox="0 0 520 260" role="img" aria-label="LiDAR scan arcs around a robot and obstacles">
        <g className="pv-grid"><path d="M0 52h520M0 104h520M0 156h520M0 208h520M65 0v260M130 0v260M195 0v260M260 0v260M325 0v260M390 0v260M455 0v260" /></g>
        <g className="pv-scan"><path d="M260 193A68 68 0 0 1 328 125M260 193A118 118 0 0 1 378 75M260 193A168 168 0 0 1 428 25" /></g>
        <g className="pv-obstacles"><rect x="348" y="141" width="58" height="44" rx="4"/><rect x="91" y="62" width="48" height="78" rx="4"/><circle cx="431" cy="72" r="22"/></g>
        <g className="pv-robot"><rect x="222" y="171" width="76" height="54" rx="14"/><circle cx="260" cy="185" r="9"/><circle cx="236" cy="222" r="10"/><circle cx="284" cy="222" r="10"/></g>
        <path className="pv-route" d="M40 214c91 0 96-48 147-46s34-69 73-88 84 6 110-30" />
        <text x="22" y="28">LIVE RANGE MAP / 01</text>
      </svg>
    );
  }

  if (type === "robot") {
    return (
      <svg className="project-visual-svg" viewBox="0 0 520 260" role="img" aria-label="Exploded blueprint of a modular robotic platform">
        <g className="pv-grid"><path d="M0 52h520M0 104h520M0 156h520M0 208h520M65 0v260M130 0v260M195 0v260M260 0v260M325 0v260M390 0v260M455 0v260" /></g>
        <g className="pv-robot-stack">
          <ellipse cx="261" cy="191" rx="126" ry="35"/><rect x="151" y="139" width="220" height="48" rx="19"/><circle cx="185" cy="196" r="23"/><circle cx="337" cy="196" r="23"/>
          <rect x="202" y="87" width="118" height="31" rx="7"/><circle cx="261" cy="60" r="25"/><path d="M261 85v26m-70 7-24 27m164-27 24 27"/>
        </g>
        <g className="pv-callouts"><path d="M285 54h108v-24h56"/><path d="M209 102H95V73H40"/><path d="M368 164h60v43h48"/></g>
        <text x="400" y="24">LiDAR</text><text x="22" y="68">COMPUTE</text><text x="424" y="225">DRIVE ×4</text>
      </svg>
    );
  }

  if (type === "ai") {
    return (
      <svg className="project-visual-svg" viewBox="0 0 520 260" role="img" aria-label="Documents moving through retrieval and model layers into an interface">
        <g className="pv-grid"><path d="M0 52h520M0 104h520M0 156h520M0 208h520M65 0v260M130 0v260M195 0v260M260 0v260M325 0v260M390 0v260M455 0v260" /></g>
        <g className="pv-flow-boxes"><rect x="30" y="75" width="105" height="112" rx="8"/><rect x="207" y="56" width="110" height="150" rx="55"/><rect x="390" y="75" width="100" height="112" rx="8"/></g>
        <g className="pv-docs"><path d="M53 100h57M53 121h45M53 142h57M53 163h34"/><circle cx="262" cy="104" r="24"/><path d="m244 159 18-21 18 21M414 103h53M414 128h38M414 153h45"/></g>
        <path className="pv-route" d="M137 131h68m114 0h69" />
        <text x="49" y="56">CONTEXT</text><text x="229" y="31">RETRIEVE</text><text x="402" y="56">INTERFACE</text>
      </svg>
    );
  }

  return (
    <svg className="project-visual-svg" viewBox="0 0 520 260" role="img" aria-label="Data pipeline flowing into application and analytics views">
      <g className="pv-grid"><path d="M0 52h520M0 104h520M0 156h520M0 208h520M65 0v260M130 0v260M195 0v260M260 0v260M325 0v260M390 0v260M455 0v260" /></g>
      <g className="pv-data-nodes"><path d="M44 83c0-16 30-29 66-29s66 13 66 29v93c0 16-30 29-66 29s-66-13-66-29Z"/><ellipse cx="110" cy="83" rx="66" ry="29"/><rect x="220" y="84" width="91" height="91" rx="8"/><rect x="365" y="55" width="120" height="150" rx="8"/></g>
      <path className="pv-route" d="M178 130h40m95 0h50" />
      <g className="pv-chart"><path d="M388 177v-43h17v43m14 0V98h17v79m14 0v-58h17v58"/><path d="M383 84h79"/></g>
      <text x="67" y="235">DATA</text><text x="224" y="235">TRANSFORM</text><text x="385" y="235">EXPLAIN</text>
    </svg>
  );
}
